import { render, staticRenderFns } from "./SelectPatient.vue?vue&type=template&id=7410d076&scoped=true"
import script from "./SelectPatient.vue?vue&type=script&lang=js"
export * from "./SelectPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7410d076",
  null
  
)

export default component.exports